import { VITE_USE_MOCK, VITE_MOCK_API, VITE_EXPORT_URL } from 'Constants/appEnvConstants'

export default function getExportUrl() {
    return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_EXPORT_URL; // eslint-disable-line no-undef
  }
  
  
